import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../axios-client";
import { queryClient } from "../query-client";

export const useGetAllModels = () =>
    useQuery({
        queryKey: ["models"],
        queryFn: async () => {
            const response = await api.get("/api/v1/models");
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 60,
    });

export const useGetModel = (id: string) =>
    useQuery({
        queryKey: ["models", id],
        queryFn: async () => {
            const response = await api.get(`/api/v1/models/${id}`);
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 60,
        enabled: !!id,
    });

export const useCreateModel = () =>
    useMutation({
        mutationFn: async (data: { name: string }) => {
            const response = await api.post("/api/v1/models", data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["models"] });
        },
    });

export const useUpdateModel = () =>
    useMutation({
        mutationFn: async ({ id, data }: { id: string; data: { name: string } }) => {
            const response = await api.put(`/api/v1/models/${id}`, data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["models"] });
        },
    });

export const useDeleteModel = () =>
    useMutation({
        mutationFn: async (id: string) => {
            const response = await api.delete(`/api/v1/models/${id}`);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["models"] });
        },
    });
